import React from 'react';
import { Menu, MenuButtonProps, MenuListProps } from '@televet/kibble-ui/build/components/Menu';

interface AutomationsSendConditionMenuBlockProps {
  buttonProps: MenuButtonProps;
  listProps: MenuListProps;
}

const AutomationsSendConditionMenuBlock = ({
  buttonProps,
  listProps,
}: AutomationsSendConditionMenuBlockProps): JSX.Element | null => (
  <Menu buttonProps={buttonProps} listProps={listProps} />
);

const customComparator = (
  prevProps: AutomationsSendConditionMenuBlockProps,
  nextProps: AutomationsSendConditionMenuBlockProps,
): boolean => JSON.stringify(prevProps.listProps?.menuItems) === JSON.stringify(nextProps.listProps?.menuItems);

export default React.memo(AutomationsSendConditionMenuBlock, customComparator);
